import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('boundaryDetailPage');

    return {
        APPLICATIONS: t('applications'),
        EDIT_BOUNDARY: t('editBoundary'),
        LINKED_ENTITIES: t('linkedEntities')
    };
};

export default useTranslation;
